import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const removeNavigationStmtInstruction = `
#### Remove Navigation Item

- Syntax: \`remove navigation "<label>";\`
- Example: \`remove navigation "Products";\`

#### Remove Child Navigation Item
Remove a child item under a parent navigation item.

- Syntax: \`remove navigation "<parentLabel>"->"<label>";\`
- Example: \`remove navigation "Catalog"->"Products";\`
`;
export const stmtRemoveNavigation = ({ label }) => {
    return `remove navigation "${label.replace(/"/g, '')}";`;
};
export const removeNavigationHandler = createStructureStatementHandler({
    type: 'remove navigation',
    parse: line => {
        const match = /^remove navigation (?<label>["]+\w.+["]+(?:->"\w.+")*)( to (?<viewName>\w+))?(?: with icon (?<icon>[\w-_]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove navigation',
                label: match.groups.label,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeNavigationItem({
                label: stmt.label,
            });
        });
    },
});
//# sourceMappingURL=RemoveNavigationStmt.js.map